 <template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم -->
    <div class="card shadow-sm mb-4 border-top-success no-print">
      <div class="card-body py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div>
          <h4 class="mb-0 fw-bold text-success">
            <i class="fas fa-book-open ms-2"></i> إحصاء المواد (غياب وحضور)
          </h4>
          <span class="text-muted small">يتم احتساب الغياب من واقع رصد درجات المادة نفسها</span>
        </div>
        
        <div class="d-flex gap-2 align-items-center flex-wrap">
          
          <!-- فلتر الإدارة -->
          <div class="input-group">
            <span class="input-group-text bg-light fw-bold">الإدارة</span>
            <select v-model="filters.administration_id" @change="fetchData" class="form-select fw-bold">
                <option value="">-- المحافظة بالكامل --</option>
                <option v-for="admin in administrations" :key="admin.id" :value="admin.id">
                {{ admin.name }}
                </option>
            </select>
          </div>

          <!-- فلتر الفصل -->
          <div class="input-group">
            <span class="input-group-text bg-light fw-bold">الفصل</span>
            <select v-model="filters.term" @change="fetchData" class="form-select fw-bold">
                <option value="term1">الترم الأول</option>
                <option value="term2">الترم الثاني</option>
                <option value="round2">الدور الثاني</option>
            </select>
          </div>
          
          <button @click="printPage" class="btn btn-dark px-4" :disabled="subjectsData.length === 0">
            <i class="fas fa-print ms-2"></i> طباعة
          </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة التقرير -->
    <div id="printMe" v-if="subjectsData.length > 0">
      
      <!-- ترويسة الطباعة -->
      <div class="text-center d-none d-print-block mb-4 pt-3 border-bottom pb-3">
        <h3 class="fw-bold">بيان إحصائي لحضور وغياب الطلاب في المواد الدراسية</h3>
        <h5 class="text-muted">العام الدراسي 2026 - {{ getTermName() }}</h5>
        <h6 v-if="filters.administration_id" class="mt-2 border p-1 d-inline-block rounded">
            إدارة: {{ getAdminName() }}
        </h6>
      </div>

      <!-- الجدول -->
      <div class="card shadow-sm border-0">
        <div class="table-responsive">
          <table class="table table-bordered table-hover text-center align-middle mb-0 custom-table">
            <thead class="bg-success text-white">
              <tr>
                <th width="5%">م</th>
                <th width="20%">المادة الدراسية</th>
                <th width="15%">إجمالي المتقدمين</th>
                <th width="15%">عدد الحضور</th>
                <th width="15%">عدد الغياب</th>
                <th width="15%">نسبة الحضور %</th>
                <th width="15%">نسبة الغياب %</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sub, index) in subjectsData" :key="sub.id">
                <td>{{ index + 1 }}</td>
                <td class="fw-bold text-start ps-4 bg-light">{{ sub.name }}</td>
                <td class="fw-bold fs-5">{{ sub.total }}</td>
                
                <!-- الحضور -->
                <td class="text-success fw-bold">{{ sub.present }}</td>
                
                <!-- الغياب -->
                <td class="text-danger fw-bold">{{ sub.absent }}</td>
                
                <!-- نسبة الحضور -->
                <td>
                  <div class="d-flex align-items-center">
                      <div class="progress flex-grow-1 ms-2 border border-success" style="height: 15px;">
                        <div class="progress-bar bg-success" :style="{width: sub.present_percent + '%'}"></div>
                      </div>
                      <small class="fw-bold">{{ sub.present_percent }}%</small>
                  </div>
                </td>

                <!-- نسبة الغياب -->
                <td>
                   <div class="d-flex align-items-center">
                      <div class="progress flex-grow-1 ms-2 border border-danger" style="height: 15px;">
                        <div class="progress-bar bg-danger" :style="{width: sub.absent_percent + '%'}"></div>
                      </div>
                      <small class="fw-bold">{{ sub.absent_percent }}%</small>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- الرسم البياني (Visual) -->
      <div class="d-print-none row mt-4">
         <div class="col-12">
             <div class="card border-0 shadow-sm">
                 <div class="card-body">
                     <h5 class="text-center text-primary fw-bold mb-3">مؤشرات الغياب في المواد</h5>
                     <GradesChart v-if="chartData.labels.length" :chartData="chartData" />
                 </div>
             </div>
         </div>
      </div>

      <!-- تذييل الطباعة -->
      <div class="mt-5 pt-5 d-none d-print-block">
          <div class="d-flex justify-content-between px-5 text-center fw-bold fs-5">
              <div>رئيس لجنة النظام والمراقبة</div>
              <div>مدير عام التعليم العام</div>
              <div>وكيل الوزارة</div>
          </div>
      </div>

    </div>

    <!-- Loading -->
    <div v-if="loading" class="text-center py-5 no-print">
        <div class="spinner-border text-success" role="status"></div>
        <p class="mt-2 fw-bold text-muted">جاري تحليل بيانات المواد...</p>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import GradesChart from '@/components/GradesChart.vue';

export default {
  name: "SubjectsStatistics",
  components: { GradesChart },
  data() {
    return {
      loading: false,
      subjectsData: [],
      chartData: { labels: [], datasets: [] },
      
      filters: {
        term: 'term1',
        administration_id: ''
      },
      
      // الإدارات (نفس القائمة السابقة)
      administrations: [
          { id: 1, name: 'العريش' }, 
          { id: 2, name: 'بئر العبد' }, 
          { id: 3, name: 'الشيخ زويد' }, 
          { id: 4, name: 'رفح' }, 
          { id: 5, name: 'الحسنة' }, 
          { id: 6, name: 'نخل' }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.subjectsData = [];
      try {
        const res = await api.get('/admin/reports/subjects-stats', { params: this.filters });
        this.subjectsData = res.data;
        this.prepareChart();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    prepareChart() {
        if(!this.subjectsData.length) return;
        
        this.chartData = {
            labels: this.subjectsData.map(s => s.name),
            datasets: [
                {
                    label: 'نسبة الحضور',
                    backgroundColor: '#198754', // أخضر
                    data: this.subjectsData.map(s => s.present_percent)
                },
                {
                    label: 'نسبة الغياب',
                    backgroundColor: '#dc3545', // أحمر
                    data: this.subjectsData.map(s => s.absent_percent)
                }
            ]
        };
    },

    getTermName() {
        const names = { 'term1': 'الفصل الدراسي الأول', 'term2': 'الفصل الدراسي الثاني', 'round2': 'الدور الثاني' };
        return names[this.filters.term];
    },
    getAdminName() {
        const admin = this.administrations.find(a => a.id == this.filters.administration_id);
        return admin ? admin.name : '';
    },
    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-success { border-top: 4px solid #198754; }

@media print {
    .no-print { display: none !important; }
    .d-print-block { display: block !important; }
    .card { border: none !important; box-shadow: none !important; }
    
    .custom-table th, .custom-table td {
        border: 2px solid #000 !important;
        font-size: 13pt !important;
        padding: 8px !important;
    }
    
    .bg-success, .bg-danger, .bg-light, .progress-bar {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}
</style>